import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order-type-bar"
}
const _hoisted_2 = { class: "order-type-bar__icon" }
const _hoisted_3 = { class: "order-type-bar__content" }
const _hoisted_4 = { class: "order-type-bar-kicker" }
const _hoisted_5 = ["title"]

import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import WCSvgIcon from '@/components/WCSvgIcon/WCSvgIcon.vue';
import useOrderTypes from '@/composables/useOrderTypes';
import useEmployee from '@/modules/employee/composables/useEmployee';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCActiveOrderTypeBadgeModern',
  setup(__props) {

const { visibleOrderTypes, currentOrderType: displayedOrderType } = useOrderTypes();
const { isNotAnEmployee } = useEmployee();
const route = useRoute();

const isCarouselVisible = ref(true);
let observer: IntersectionObserver | null = null;

const isMotEnabled = computed(() => (visibleOrderTypes.value?.length ?? 0) > 1);
const isCheckoutRoute = computed(() => route.path === '/co' || route.path.startsWith('/scan/co'));
const isHomePage = computed(() => route.name === 'Home');

const isEligibleForBadge = computed(
  () => Boolean(displayedOrderType.value) && isNotAnEmployee.value && isMotEnabled.value,
);

const shouldShowBadge = computed(() => {
  if (!isEligibleForBadge.value) return false;
  if (isCheckoutRoute.value) return false;
  if (isHomePage.value) return !isCarouselVisible.value;
  return true;
});

onMounted(() => {
  const el = document.querySelector<HTMLElement>('.wc-mobile-ot-switcher');
  if (typeof IntersectionObserver !== 'function' || !el) {
    isCarouselVisible.value = false;
    return;
  }
  observer = new IntersectionObserver(
    ([entry]) => {
      isCarouselVisible.value = entry.isIntersecting;
    },
    { threshold: 0.1 },
  );
  observer.observe(el);
});

onUnmounted(() => {
  observer?.disconnect();
  observer = null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "wc-active-order-type-badge" }, {
    default: _withCtx(() => [
      (shouldShowBadge.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(WCSvgIcon, {
                name: "basket-shopping",
                "icon-size": "md"
              })
            ]),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('youAreShopping')), 1),
              _cache[0] || (_cache[0] = _createTextVNode()),
              _createElementVNode("span", {
                class: "order-type-bar-value",
                title: _unref(displayedOrderType)?.name
              }, _toDisplayString(_unref(displayedOrderType)?.name), 9, _hoisted_5)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})